import { render, staticRenderFns } from "./OrderCard.vue?vue&type=template&id=589a4a30&scoped=true&"
import script from "./OrderCard.vue?vue&type=script&lang=ts&"
export * from "./OrderCard.vue?vue&type=script&lang=ts&"
import style0 from "./OrderCard.vue?vue&type=style&index=0&id=589a4a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589a4a30",
  null
  
)

export default component.exports